import React, {Component} from 'react';
import {Link} from 'react-router'
import Icon from '../../components/icon';
import LocalizedStrings from '../../localization/strings';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as userActions from '../../actions/users';
import DocumentTitle from 'react-document-title';
import {
    saveLanguageCookie
} from '../../localization/language-cookie';

class AdminContainer extends Component {
    logout() {
        this.props.actions.logout();
        window.USER_LOGGED = false;
    }

    render() {
        return (
            <DocumentTitle title={`Admin | ${window.CARE_CONFIG.settings.title}`}>

                <div className="admin-board">
                    <div className="header">
                        <div className="branding">
                            <a href="http://www.eventomania.lt" activeClassName="active">
                                <img src={require('../../../images/eventomania-dark.png')}/>
                            </a>
                        </div>
                        <div className="right-col">
                            <ul className="nav">
                                <li className="btn">
                                    <Link to={'/'} activeClassName="active">{LocalizedStrings.viewSite}</Link>
                                </li>
                                <li className="btn">
                                    <Link to={'/'} activeClassName="active"
                                          onClick={this.logout.bind(this)}>{LocalizedStrings.logout}</Link>
                                </li>
                            </ul>

                        </div>
                    </div>
                    <div className="content">
                        <div className="left-col">
                            <ul className="side-menu">
                                <li>
                                    <Link to={'/admin'}>
                                        <div className="title">{LocalizedStrings.statistics}</div>
                                        <Icon icon="chevron-right" size="ss"></Icon>
                                    </Link>
                                </li>
                                <li>
                                    <Link to={'/admin/seasons/'} activeClassName="active">
                                        <div className="title">{LocalizedStrings.seasons}</div>
                                        <Icon icon="chevron-right" size="ss"></Icon>
                                    </Link>
                                </li>
                                <li>
                                    <Link to={'/admin/stages/'} activeClassName="active">
                                        <div className="title">{LocalizedStrings.stages}</div>
                                        <Icon icon="chevron-right" size="ss"></Icon>
                                    </Link>
                                </li>
                                <li>
                                    <Link to={'/admin/participants/'} activeClassName="active">
                                        <div className="title">{LocalizedStrings.participants}</div>
                                        <Icon icon="chevron-right" size="ss"></Icon>
                                    </Link>
                                </li>
                                <li>
                                    <Link to={'/admin/partners/'} activeClassName="active">
                                        <div className="title">{LocalizedStrings.partners}</div>
                                        <Icon icon="chevron-right" size="ss"></Icon>
                                    </Link>
                                </li>
                                <li>
                                    <Link to={'/admin/partner-categories/'} activeClassName="active">
                                        <div className="title">{LocalizedStrings.partnerCategories}</div>
                                        <Icon icon="chevron-right" size="ss"></Icon>
                                    </Link>
                                </li>
                                <li>
                                    <Link to={'/admin/posts/'} activeClassName="active">
                                        <div className="title">{LocalizedStrings.posts}</div>
                                        <Icon icon="chevron-right" size="ss"></Icon>
                                    </Link>
                                </li>
                                <li>
                                    <Link to={'/admin/export/'} activeClassName="active">
                                        <div className="title">{LocalizedStrings.export}</div>
                                        <Icon icon="chevron-right" size="ss"></Icon>
                                    </Link>
                                </li>
                                <li>
                                    <Link to={'/admin/images/'} activeClassName="active">
                                        <div className="title">{LocalizedStrings.images}</div>
                                        <Icon icon="chevron-right" size="ss"></Icon>
                                    </Link>
                                </li>
                                <li>
                                    <Link to={'/admin/promo-codes/'} activeClassName="active">
                                        <div className="title">{LocalizedStrings.promoCodes}</div>
                                        <Icon icon="chevron-right" size="ss" />
                                    </Link>
                                </li>

                                {window.CARE_CONFIG.invoicesEnabled && <li>
                                    <Link to={'/admin/invoices/'} activeClassName="active">
                                        <div className="title">{LocalizedStrings.invoices}</div>
                                        <Icon icon="chevron-right" size="ss" />
                                    </Link>
                                </li>}

                                <li>
                                    <Link to={'/admin/participant-results'} activeClassName="active">
                                        <div className="title">{LocalizedStrings.participantResults}</div>
                                        <Icon icon="chevron-right" size="ss"></Icon>
                                    </Link>
                                </li>

                                <li>
                                    <Link to={'/admin/settings'} activeClassName="active">
                                        <div className="title">{LocalizedStrings.settings}</div>
                                        <Icon icon="chevron-right" size="ss"></Icon>
                                    </Link>
                                </li>
                                <li>
                                    <Link to={'/admin/config'} activeClassName="active">
                                        <div className="title">{LocalizedStrings.configuration}</div>
                                        <Icon icon="chevron-right" size="ss"></Icon>
                                    </Link>
                                </li>
                            </ul>
                            <div style={{ padding: '8px 15px' }}>
                                {['lt', 'en'].map(
                                  (lang) => {
                                      return <a style={{ paddingRight: '10px', textTransform: 'uppercase' }}
                                                onClick={() => {
                                                    saveLanguageCookie(lang);
                                                      window.location.reload();
                                                  }} key={lang}>{lang}</a>
                                    }
                                )}
                            </div>
                        </div>
                        <div className="right-col">
                            {this.props.children}
                        </div>
                    </div>

                </div>
            </DocumentTitle>
        )
    }
}

export default connect(() => {
    return {};
}, function (dispatch) {
    return {
        actions: bindActionCreators({
            ...userActions
        }, dispatch)
    };
})(AdminContainer);



// WEBPACK FOOTER //
// ./src/js/containers/admin/admin-container.js